import React, { useEffect, useRef, useState } from "react";

// If your video is in /public/videos/NarfClinic.mp4, use:
// const VIDEO_SRC = "/videos/NarfClinic.mp4";

// If your video is in src/videos, you can import it like:
// import videoSrc from "../videos/NarfClinic.mp4";
// const VIDEO_SRC = videoSrc;

import videoSrc from "../images/NarfClinic.mp4";
import posterSrc from "../images/narfBuilding.jpeg";

const VIDEO_SRC = videoSrc;
const POSTER_SRC = posterSrc;

export default function HomeVideoSection({
  title = "",
  subtitle = "",
  className = "",
}) {
  const containerRef = useRef(null);
  const videoRef = useRef(null);
  const [shouldLoad, setShouldLoad] = useState(false);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    // Load a bit BEFORE it appears, so playback feels instant.
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShouldLoad(true);
          observer.disconnect();
        }
      },
      { root: null, rootMargin: "250px 0px", threshold: 0.01 }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!shouldLoad) return;
    const v = videoRef.current;
    if (!v) return;

    // Some browsers need load() after setting src dynamically
    v.load();

    const tryPlay = async () => {
      try {
        await v.play();
      } catch (e) {
        // Autoplay might be blocked; user can press play
        // (Also likely if you're testing with Low Power Mode / iOS settings)
        console.log("Autoplay blocked:", e);
      }
    };

    tryPlay();
  }, [shouldLoad]);

  return (
    <section ref={containerRef} className={`relative ${className}`}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="py-10 md:py-14">
          <div className="text-center mb-6 md:mb-8">
            <h2 className="text-2xl md:text-3xl font-bold leading-tight">
              {title}
            </h2>
            {subtitle ? (
              <p className="text-gray-600 mt-2 max-w-2xl mx-auto">{subtitle}</p>
            ) : null}
          </div>

          <div className="relative mx-auto max-w-4xl overflow-hidden rounded-xl shadow-lg">
            <video
              ref={videoRef}
              className="w-full h-auto"
              poster={POSTER_SRC}
              muted
              playsInline
              loop
              autoPlay
              controls
              preload="metadata"
              src={shouldLoad ? VIDEO_SRC : undefined}
              onCanPlay={() => {
                // Helpful in Safari: ensure it starts once it's actually ready
                const v = videoRef.current;
                if (v && v.paused) v.play().catch(() => {});
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
